import { applyMetaToChildren } from '@/utils/router'

export const settingsRouter = applyMetaToChildren(
  [
    {
      children: [
        {
          card: 'general',
        },
        {
          card: 'funnel',
        },
        {
          card: 'notifications',
        },
        {
          card: 'address',
        },
        {
          card: 'contact',
        },
        {
          card: 'fulfillment',
        },
        {
          card: 'integrations',
        },
        {
          card: 'sms-marketing',
        },
        {
          acl: {
            roles: ['pb:super'],
          },
          card: 'payments',
        },
        {
          acl: {
            roles: ['pb:super'],
          },
          card: 'subscriptions',
        },
        {
          acl: {
            roles: ['pb:super'],
          },
          card: 'features',
        },
      ].map(({ acl, card }) => ({
        component: async () => import('../views/SettingsView.vue'),
        meta: {
          ...acl,
          brandRedirect: 'brand.settings',
          isLocationPage: true,
          title: 'settings',
        },
        name: `location.settings.${card}`,
        path: card,
      })),
      component: {
        name: 'LocationSettingsRouterView',
        // eslint-disable-next-line xss/no-mixed-html
        template: '<router-view></router-view>',
      },
      name: `location.settings`,
      path: 'settings',
      redirect: { name: 'location.settings.general' },
    },
  ],
  {
    scopes: ['locations:update'],
    title: 'settings',
  }
)
